export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.dev || typeof window === "undefined") return;

  (window as any).__pinia = nuxtApp.$pinia;
});
